@if (isLoader) {
  <app-sidebar-header (close)="close.emit()" [title]="'neuron_another_crm' | translate" />
  <div class="neuron-loader-container">
    <app-loader size="big"></app-loader>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <div class="h-100 overflow-auto crm-scroll neuron-keycrm-container">
    <app-sidebar-header (close)="close.emit()" [title]="'neuron_another_crm' | translate" />
    <mat-card class="shadow-none bg-transparent">
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <div class="header-container">
          <div class="icon-logo">
            <img src="/assets/images/other/ic_neuron.png" alt="Neuron logo" />
          </div>
          <h5 class="neuron-integration-description">{{ 'connect_neuron_to_another_crm' | translate }}</h5>
        </div>

        <div class="pt-4">
          <p>
            {{ 'status' | translate }}:
            @if (NEURON_INTEGRATION_STATUS_OBJECT[status]) {
              <span class="badge" [ngStyle]="{ 'background-color': NEURON_INTEGRATION_STATUS_OBJECT[status].color }">
                {{ 'channel_status_new.' + NEURON_INTEGRATION_STATUS_OBJECT[status].textKey | translate }}
              </span>
            }
            @if (selectedCrm && selectedCrm !== ANOTHER_CRM_TYPE.UNKNOWN) {
              <div class="pb-4">
                <app-button btnType="stroked" (onChangeClick)="copyWebhookUrl()">
                  {{ 'copy_webhook_url' | translate }}
                </app-button>
              </div>
            }
          </p>
        </div>

        <div class="d-flex gap-2 flex-wrap flex-column justify-content-center">
          @if (status !== NEURON_INTEGRATION_STATUS.CONNECTED) {
            <app-select
              labelType="float"
              class="select"
              optionValue="value"
              optionLabel="name"
              placeholder="{{ 'select' | translate }}"
              [isTranslate]="true"
              [showClear]="true"
              [options]="neuronAndAnotherCrmService.anotherCrmTypes"
              [formControl]="crmControl"
              (valueChange)="onSelectCrm()"
              [isImg]="true"
            />

            @switch (crmControl.value) {
              @case (ANOTHER_CRM_TYPE.KEY_CRM) {
                <ng-container *ngTemplateOutlet="tokenWithDomain"></ng-container>
              }
              @case (ANOTHER_CRM_TYPE.SALES_DRIVE) {
                <ng-container *ngTemplateOutlet="tokenWithDomain"></ng-container>
              }
              @case (ANOTHER_CRM_TYPE.KEEPINCRM) {
                <ng-container *ngTemplateOutlet="tokenWithDomain"></ng-container>
              }
            }
          } @else {
            <app-button class="d-flex justify-content-center" (onChangeClick)="delete()"
              >{{ 'delete' | translate }}
            </app-button>
          }
        </div>
      </mat-card-content>
    </mat-card>

    @if (integration) {
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <h5>{{ 'information' | translate }}</h5>
        <mat-divider class="mb-3"></mat-divider>
        @if (integration.another_crm_type) {
          <p class="text-secondary">
            {{ 'crm' | translate }}:
            <span class="text-dark">{{ 'another_crm.' + integration.another_crm_type.toLowerCase() | translate }}</span>
          </p>
        }
        @if (integration.x_data.api_key) {
          <p class="text-secondary">
            {{ 'api_key' | translate }}: <span class="text-dark">{{ integration.x_data.api_key }}</span>
          </p>
        }
        @if (integration.x_data.domain) {
          <p class="text-secondary">
            {{ 'domain_capitalized' | translate }}: <span class="text-dark">{{ integration.x_data.domain }}</span>
          </p>
        }
      </mat-card-content>
    }
  </div>
</ng-template>

<ng-template #tokenWithDomain>
  <ng-container [formGroup]="formGroup">
    <app-input
      [variant]="'on'"
      [inputType]="'default'"
      [formControl]="formGroup.controls.apiKeyControl"
      [id]="'api-key'"
      [invalid]="formGroup.controls.apiKeyControl.touched && formGroup.controls.apiKeyControl.invalid"
      [required]="true"
      [optionValue]="'value'"
      [optionLabel]="'title'"
      placeholder="{{ 'token' | translate }}"
      label="{{ 'token' | translate }}"
    />

    <app-input
      [variant]="'on'"
      [inputType]="'default'"
      [formControl]="formGroup.controls.domainControl"
      [id]="'domain'"
      [invalid]="formGroup.controls.domainControl.touched && formGroup.controls.domainControl.invalid"
      [required]="true"
      [optionValue]="'value'"
      [optionLabel]="'title'"
      placeholder="domain.jecrm.org"
      label="{{ 'domain_in_format' | translate }}"
    />
  </ng-container>
  <app-button class="d-flex justify-content-center" (onChangeClick)="connect()"
    >{{ 'connect' | translate }}
  </app-button>
</ng-template>
